/** Shopify CDN: Minification failed

Line 16:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 17:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 18:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 19:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 20:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 22:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 43:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 45:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 49:4 Transforming let to the configured target environment ("es5") is not supported yet
... and 9 more hidden warnings

**/
let category_select_id = "dropdown-field_5";
let category_select_field = "field_5";
let ymm_not_filled_title = "Please select year, make and model.";
let all_products_title = "All Products";
let category_prefix_1 = "ir_";

let category_images = {}
category_images["-1"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/BBGL-46-264503_1.jpg";
category_images[category_prefix_1 + "air-and-fuel-delivery"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/BBMX-HFP274A.jpg";
category_images[category_prefix_1 + "belts-and-cooling"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/belts-and-cooling.jpg";
category_images[category_prefix_1 + "brake"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/brake.jpg";
category_images[category_prefix_1 + "driveline-and-axles"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/driveline-and-axles.jpg";
category_images[category_prefix_1  + "emission-control"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/BBMX-EG10026A.jpg";
category_images[category_prefix_1 + "engine"] =  "";
category_images[category_prefix_1 + "heat-and-air-conditioning"] = "";
category_images[category_prefix_1 + "ignition"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/CFPQ-E3.64.jpg";
category_images[category_prefix_1 + "lighting-body"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/ZUKT-111117.jpg";
category_images[category_prefix_1 + "steering"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/steering.jpg";
category_images[category_prefix_1 + "suspension"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/suspension.jpg";
category_images[category_prefix_1 + "kits"] = "https://cdn.shopify.com/s/files/1/0651/2164/8860/files/brake-kit.jpg";

function get_category_image(val) {
  return category_images[val] + "?width=533";
}

function getCategories() {

  let ymm_categories_container = jQuery("#ymm-categories");
  ymm_categories_container.empty();
  let options = jQuery("#" + category_select_id + ":enabled option");

  if (options.length > 1) {
    let values = [];
    let texts = [];
    let suspension_value = "";
    let suspension_text = "";
    for (let i = 0; i < options.length; i++) {
      if (options[i].value != "-1") {
        if (options[i].value == category_prefix_1 + "suspension") {
          suspension_value = options[i].value;
          suspension_text = options[i].text;
        } else {
          values.push(options[i].value);
          texts.push(options[i].text);
        }
      }
    }
    values.push("-1");
    texts.push(all_products_title);

    
    let ymm_categories_list = jQuery('<ul class="grid contains-card--collection grid--4-col-desktop grid--2-col-tablet-down"></ul>');

    if (suspension_value.length) {
      let ymm_category = '<li class="grid__item">' + createElementCategory(suspension_text, suspension_value, get_category_image(suspension_value)) + "</li>";
      ymm_categories_list.append(ymm_category)
    }
    
    for (let i = 0; i < values.length; i++) {
      let ymm_category = '<li class="grid__item">' +  (texts[i], values[i], get_category_image(values[i])) + "</li>";
      ymm_categories_list.append(ymm_category)
    }

    ymm_categories_container.append(ymm_categories_list);
    ymm_categories_container.find("ul li .ymm-category").on("click", function () {  
      let select_value = jQuery(this).attr("data-select-value");  
      jQuery("#ymm_searchbox #" + category_select_id).val(select_value);
      jQuery("li." + category_select_field).nextAll().find("select").val("-1");
      jQuery("#ymm_searchbox #ymm_search").click();
    }) 
  } else {
    jQuery("#page-title-ymm").text(ymm_not_filled_title);
  }
}


function createElementCategory(e_text, e_value, e_image) {
  let div = '<div class="ymm-category card card--card card--media" data-select-value="' + e_value + '" style="--ratio-percent: 100%;">' + 
                '<div class="inner__card ratio" style="--ratio-percent: 100%;" >' + 
                    '<div class="card__media">' + 
                      '<div class="category-image media media--hover-effect" style="background-color: #00000000">' + 
                          '<img src="' + e_image + '">' +
                      '</div>' +
                    '</div>' + 
                '</div>' + 
                '<div class="category-title card__content">' + 
                  '<div class="card__information">' + 
                    '<h3 class="card__heading">' + e_text + '</h3>' +
                  '</div>' +
                '</div>' +
            '</div>';
  return div;
}

